import { Link } from "react-router";
import PageMeta from "../components/PageMeta";
import { Footer } from "../components/Footer";
import BrandLogo from "../components/BrandLogo";
import { routerContent } from "../content/router";
import { trackEvent } from "../services/analytics";

function RouterCard({ card, onClick }) {
  return (
    <Link
      to={card.to}
      onClick={() => onClick(card.id)}
      className={`group block md:flex-1 rounded-xl bg-white/10 backdrop-blur border border-white/20 hover:bg-white/20 hover:scale-[1.01] transition-all duration-300 ${
        card.id === "candidat"
          ? "hover:border-brand-accent1/50"
          : "hover:border-brand-accent2/50"
      }`}
    >
      <div className="flex flex-col h-full p-4 lg:p-5 text-white">
        <h2 className="text-lg lg:text-xl font-bold mb-1.5 group-hover:text-yellow-200 transition">
          {card.title}
        </h2>
        <p className="text-white/85 text-sm leading-relaxed mb-3">
          {card.description}
        </p>
        <span className="mt-auto self-start inline-block font-semibold text-xs uppercase tracking-wide text-white bg-white/20 group-hover:bg-white/30 px-3 py-1.5 rounded-full transition">
          {card.cta} →
        </span>
      </div>
    </Link>
  );
}

export default function RouterPage() {
  const { meta, hero, cards } = routerContent;

  const handleCardClick = (cardId) => {
    trackEvent("cta_click", { location: "router_card", variant: cardId });
  };

  return (
    <>
      <PageMeta title={meta.title} description={meta.description} path="/" />
      <div className="min-h-screen flex flex-col bg-gradient-to-br from-brand-primary to-brand-secondary">
        <nav
          aria-label="Accueil"
          className="md:hidden fixed top-0 left-0 w-full z-50 bg-gradient-to-r from-brand-primary to-brand-secondary bg-opacity-95 backdrop-blur shadow-sm"
        >
          <div className="container mx-auto px-4 py-3 grid grid-cols-[1fr_auto_1fr] items-center">
            <BrandLogo className="h-9 justify-self-start" linkTo={null} />
            <h1 className="text-lg font-bold text-white tracking-tight text-center">
              {hero.title}
            </h1>
            <div aria-hidden="true" />
          </div>
        </nav>

        <header className="hidden md:block shrink-0 px-6 lg:px-10 pt-3 pb-2 lg:pb-4">
          <BrandLogo className="h-10" />
        </header>

        <div className="flex-1 flex flex-col md:grid md:grid-cols-[1.5fr_1fr] md:grid-rows-[auto_auto] container mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-10 md:gap-x-10 lg:gap-x-16 md:gap-y-6 lg:gap-y-8 md:min-h-0 md:py-6 lg:py-8 text-white">
          <div className="order-2 md:col-start-1 md:row-start-1 md:self-start min-w-0 text-center md:text-left md:pt-4 lg:pt-6">
            <h1 className="hidden md:block text-4xl lg:text-5xl xl:text-6xl font-bold mb-4 md:mb-8 lg:mb-10 leading-[1.1]">
              {hero.title}
            </h1>
            <p className="text-white/85 max-w-xl md:max-w-lg mx-auto md:mx-0 text-base sm:text-lg lg:text-xl xl:text-2xl leading-snug md:leading-relaxed">
              {hero.tagline}
            </p>
          </div>

          {hero.image && (
            <div className="order-1 md:col-start-2 md:row-start-1 md:row-span-2 md:self-center flex justify-center pt-16 md:pt-0 mb-4 md:mb-0">
              <img
                src={hero.image}
                alt={hero.imageAlt}
                className="w-full max-w-[200px] sm:max-w-[240px] md:max-w-[320px] lg:max-w-[400px] xl:max-w-[460px] h-auto drop-shadow-lg"
              />
            </div>
          )}

          <div className="order-3 md:col-start-1 md:row-start-2 md:self-start w-full flex flex-col md:flex-row md:items-stretch gap-3 md:gap-6 lg:gap-8 mt-6 md:mt-0 md:pb-2 lg:pb-4 pb-10">
            {cards.map((card) => (
              <RouterCard key={card.id} card={card} onClick={handleCardClick} />
            ))}
          </div>
        </div>

        <Footer compact />
      </div>
    </>
  );
}
